export const SET_CHART_TYPE = "SET_CHART_TYPE";
export const SET_CHART_FILTER = "SET_CHART_FILTER";
